import { NonIdealState } from "@blueprintjs/core";
import React from "react";
import { connect } from "react-redux";

import { IActiveArgs } from "core/actions/editActions";
import initialState from "core/reducers/initialState";
import ConfigForm, { ConfigFormType } from "./ConfigForm";
import PanelEdit from "./panels/PanelEdit";
import ViewConfigForm from "./views/ViewConfigForm";


/**
 * renders corresponding edit panel for different types of active things.
 *
 * @author chris
 */

interface IActiveEditStateProps {
	active: IActiveArgs | null;
}


function mapStateToProps(state: typeof initialState = initialState): IActiveEditStateProps {

	return {
		active: state.edit.active
	};
}


const ActiveEdit: React.SFC<IActiveEditStateProps> = ({active}) => {

	if (active && active.type === 'panel') {
		return <PanelEdit instance={active.instance} verticalNav={false} />;
	}

	if (active && active.type === 'view') {
		return <ViewConfigForm id={active.id} instance={active.instance} />;
	}

	return (
		<NonIdealState
			title="Nothing Selected"
			description="Select a panel or view variant to edit."
		/>
	);
};

export default connect(mapStateToProps)(ActiveEdit);



// WEBPACK FOOTER //
// ./src/core/components/editor/ActiveEdit.tsx